import { render, staticRenderFns } from "./WrapperLayout.vue?vue&type=template&id=cd9ecdba&scoped=true&"
import script from "./WrapperLayout.vue?vue&type=script&lang=js&"
export * from "./WrapperLayout.vue?vue&type=script&lang=js&"
import style0 from "./WrapperLayout.vue?vue&type=style&index=0&id=cd9ecdba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9ecdba",
  null
  
)

export default component.exports